import { render, staticRenderFns } from "./AppBarToolbarItemsComponent.vue?vue&type=template&id=a8a3bcee&scoped=true&lang=pug"
import script from "./AppBarToolbarItemsComponent.vue?vue&type=script&lang=ts"
export * from "./AppBarToolbarItemsComponent.vue?vue&type=script&lang=ts"
import style0 from "./AppBarToolbarItemsComponent.vue?vue&type=style&index=0&id=a8a3bcee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a3bcee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8a3bcee')) {
      api.createRecord('a8a3bcee', component.options)
    } else {
      api.reload('a8a3bcee', component.options)
    }
    module.hot.accept("./AppBarToolbarItemsComponent.vue?vue&type=template&id=a8a3bcee&scoped=true&lang=pug", function () {
      api.rerender('a8a3bcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/AppBarToolbarItems/AppBarToolbarItemsComponent.vue"
export default component.exports